import { render } from "./ViewerSearchResultPage.vue?vue&type=template&id=38b85f71&scoped=true"
import script from "./ViewerSearchResultPage.vue?vue&type=script&lang=js"
export * from "./ViewerSearchResultPage.vue?vue&type=script&lang=js"

import "./ViewerSearchResultPage.vue?vue&type=style&index=0&id=38b85f71&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b85f71"]])

export default __exports__